<template>
   <div>
       <label class="btn upload-photo__avatar" v-if="imgSrc == null && photo == null && !load" :class="width == 495 ? 'upload-photo__avatar--16-9': '' ">
            <input type="file" accept="image/*" class="upload-photo__input" @change="setImage">
            <span class="upload-photo__avatar-inner">
                <svg width="21" height="21">
                <use xlink:href="/assets/front/img/sprite.svg#icon-camera"></use>
            </svg>
            <span class="upload-photo__avatar-text">{{ cropperButtonText }}</span>
            </span>
       </label>
       <img src="/assets/front/img/spinner.svg" v-if="imgSrc == null && load" :style="{ 'width': width + 'px', 'height': height + 'px' }">
       <vue-cropper v-if="imgSrc && photo == null"
                    ref="cropper"
                    :guides="true"
                    :view-mode="2"
                    drag-mode="crop"
                    :auto-crop-area="0.5"
                    :auto-crop-width="width"
                    :auto-crop-height="height"
                    :background="true"
                    :rotatable="false"
                    :src="imgSrc"
                    :img-style="{ 'width': width + 'px', 'height': height + 'px' }"
                    :aspect-ratio="ratio"
       ></vue-cropper>
       <button type="button" @click="cropImage" v-if="imgSrc && photo == null" style="margin-top: 10px;" class="btn btn--small btn--main-bg add__video-button">{{ $lang('cropper.button2') }}</button>
       <img v-if="photo" :src="photo" class="upload-photo__avatar-img" :style="{ 'width': width + 'px', 'height': height + 'px' }">
       <button type="button" @click="deleteImage" v-if="photo" style="margin-top: 10px;" class="btn btn--small btn--main-bg add__video-button">{{ $lang('cropper.button3') }}</button>
   </div>

</template>

<script>
    import VueCropper from "vue-cropperjs";
    import "cropperjs/dist/cropper.css";
    import helper from '../../mixins/helper';

    export default {
        name: "cropper",
        data: () => ({
            imgSrc: null,
            load: false,
        }),
        mixins:[helper],
        components: { VueCropper },
        props: ['photo', 'width', 'height', 'ratio', 'buttonText'],
        methods: {
            setImage(e) {
                this.load = true;

                const file = e.target.files[0];

                if (!file.type.includes("image/")) {
                    this.$appNotify.error("Пожалуйста, выберите файл типа изображение");
                    this.load = false;
                    return;
                }

                if (typeof FileReader === "function") {
                    const reader = new FileReader();

                    reader.onload = event => {
                        this.downscaleImage(event.srcElement.result, 870, file.type,(data) => {

                            this.imgSrc = data;
                            console.log(this.imgSrc)
                            this.load = false;
                        });
                    };
                    reader.readAsDataURL(file);

                    this.$emit('crop');
                } else {
                    this.load = false;
                    this.$appNotify.error("К сожалению, FileReader API не поддерживается");
                }
            },
            cropImage() {
                this.$emit('update-photo', this.$refs.cropper.getCroppedCanvas().toDataURL());
            },
            deleteImage() {
                this.$emit('update-photo', null);
                this.imgSrc = null;
            },
        },
        mounted() {
            this.$on('resetImgSrc', () => {
                this.imgSrc = null;
            })
        },
        computed: {
            cropperButtonText() {
                return  this.buttonText ?? this.$lang('cropper.button');
            }
        }
    }
</script>
